import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExgWidgetComponent} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-overlay-file-management',
  templateUrl: './overlay-file-management.component.html',
  styles: []
})
export class OverlayFileManagementComponent extends ExcTranslation implements OnInit{
  @ViewChild('widget', {read: ExgWidgetComponent}) widget!: ExgWidgetComponent;

  @Input()
  set data(value: any) {
    if (value) {
      this._data = value;
    }
  }
  get data(): any {
    return this._data;
  }
  private _data: any = {};

  currentWidget = 'FileOverviewComponent';
  public sidemenu = [
    {type: 0, icon: '', caption: '', component: null, disabled: false},
    {type: 1, icon: 'far fa-file', caption: this.getRessource('Files'), component: 'FileOverviewComponent', disabled: false},
    {type: 1, icon: 'far fa-file-invoice-dollar', caption: this.getGlobal('Receipts'), component: 'FileOverviewComponent', disabled: true}
  ];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.setTaskOrCaseCaption();
  }

  private setTaskOrCaseCaption(): void {
    if (this.data?.vorgID) {
      this.sidemenu[0].caption = this.getGlobal('Task');
    } else if (this.data?.auID) {
      this.sidemenu[0].caption = this.getGlobal('Case');
    }
  }

  onSidemenueClick(component: string | null): void {
    if (component) {
      this.currentWidget = component;
    }
  }
}
